import { pharmacyClient } from '@/connect'
import { Loading } from '@/layouts/loading'
import getCompanyCode from '@/utils/company_code'
import { createFileRoute } from '@tanstack/react-router'
import DashboardScreen from './-components/screen'

export const Route = createFileRoute('/company/_layout/dashboard/')({
  component: DashboardScreen,
  loader: async () => {
    // Company-level data - this could be aggregated data from all branches
    const branchesOverview = await pharmacyClient.getBranchesForCompany({
      companyCode: getCompanyCode(),
    })
    return {
      branchesOverview
    }
  },
  pendingComponent: () => <Loading />,
  pendingMinMs: 1000,
  pendingMs: 1,
})